import React from 'react';
import { Factory } from '../Blocks/factory';
import styles from './BuildPreview.module.css';
import { TemplateBlock } from 'concepts/Extraction/Blocks/BaseBlock';
import { TemplateViewModel } from 'concepts/Extraction/ViewModel/TemplateViewModel';

export type BuildPreviewProps = {
  viewModel: TemplateViewModel;
};

const PreviewItem = React.memo(function PreviewItem({
  block,
}: {
  block: TemplateBlock;
}): JSX.Element {
  const Preview = Factory(block).Preview;

  return (
    <div className={styles.item} data-preview-block-id={block.id}>
      <Preview block={block} />
    </div>
  );
});

export default function BuildPreview({
  viewModel,
}: BuildPreviewProps): JSX.Element {
  return (
    <article>
      {viewModel.blocks.map((block) => (
        <PreviewItem key={block.id} block={block} />
      ))}
    </article>
  );
}
